module.exports = __webpack_public_path__ + "img/TechArmorWall1_ua.26e54504.webp";